import ogTableDef from "./getOgDefs";

const processSingleItemForOgDef = singleItem => {
  let newDefSingleItem = {
    selectorSource: {
      type: "",
      table: "",
      tableField: "",
      staticSource: []
    }
  };
  Object.keys(singleItem).map(key => {
    if (key === "selectorType") {
      newDefSingleItem.selectorSource.type = singleItem.selectorType;
      if (singleItem.selectorType === "static") {
        newDefSingleItem.selectorSource.table = "";
        newDefSingleItem.selectorSource.tableField = "name";
      } else {
        newDefSingleItem.selectorSource.table =
          singleItem.table && singleItem.table !== undefined
            ? singleItem.table
            : "";
        newDefSingleItem.selectorSource.tableField =
          singleItem.tableField && singleItem.tableField !== undefined
            ? singleItem.tableField
            : "";
      }
    } else if (key === "staticSource") {
      newDefSingleItem.selectorSource.staticSource = singleItem.staticSource;
    } else if (key === "table") {
    } else if (key === "tableField") {
    } else {
      newDefSingleItem[key] = singleItem[key];
    }
  });
  return newDefSingleItem;
};

const getFormattedInOgDef = fields => {
  let ogDef = {};
  if (fields && fields.length > 0) {
    ogDef = fields.reduce((prevValue, currValue, currIndex, fullArray) => {
      if (prevValue !== 0) {
        prevValue[currValue.name] = processSingleItemForOgDef(currValue);
        return prevValue;
      } else {
        prevValue = {};
        prevValue[currValue.name] = processSingleItemForOgDef(currValue);
        return prevValue;
      }
    }, 0);
  }
  //console.log(JSON.stringify(ogDef));
  return ogDef;
};

const getExtendedOgDefs = createTable => {
  //console.log("~ recvd: createTable: " + JSON.stringify(createTable));
  //console.log("~ recvd: tableList: " + JSON.stringify(tableList));
  if (createTable && createTable.length > 0) {
    for (let i = 0; i < createTable.length; i++) {
      let genFormDef = getFormattedInOgDef(createTable[i]["fields"]);
      ogTableDef[createTable[i].name] = genFormDef;
    }
  }

  return ogTableDef;
};

export default getExtendedOgDefs;



// WEBPACK FOOTER //
// ./src/app/components/TableDefinitions/extendedOgDef.jsx